import clsx from 'clsx';

import styles from '@common/atoms/ProgressBar/ProgressBar.module.scss';

export interface Props {
    className?: string;
    percentage: number;
}

export const ProgressBar = ({ className, percentage }: Props) => {
    return (
        <div className={clsx(styles['progress-bar'], className)}>
            <div className={styles['track']}>
                <div className={styles['indicator']} dir="rtl" style={{ width: `${percentage}%` }} />
            </div>
            <span className={styles['text']}>{percentage}%</span>
        </div>
    );
};
